import { Injectable } from '@angular/core';
import { filter, switchMap, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { DataProtectionNoticeItemFileStateModel } from '../../../store/state/administration/data-protection-notice/item-file/data-protection-notice-item-file.state';
import { DataProtectionNoticeItemFileFacade } from '../../../store/state/administration/data-protection-notice/item-file/data-protection-notice-item-file.facade';
import { HtmlViewDialogComponent } from '../../../ui-kit/html-view-dialog/html-view-dialog.component';
import { DIALOG_DEFAULT_CONFIG, DialogSize } from '../../constants/dialog-config';

@Injectable({
  providedIn: 'root',
})
export class DataProtectionNoticeService {
  constructor(private dpnItemFileFacade: DataProtectionNoticeItemFileFacade, private sanitizer: DomSanitizer) {}

  openDpnText(dialog: MatDialog): void {
    this.dpnItemFileFacade.dpnItemFileData$
      .pipe(
        filter(({ loaded }: DataProtectionNoticeItemFileStateModel) => loaded),
        take(1),
        switchMap(({ dpnFileText }: DataProtectionNoticeItemFileStateModel) => {
          const data = this.sanitizer.bypassSecurityTrustHtml(decodeURIComponent(escape(atob(dpnFileText))));

          return dialog
            .open(HtmlViewDialogComponent, {
              ...DIALOG_DEFAULT_CONFIG,
              width: DialogSize.LG,
              data,
            })
            .afterClosed()
            .pipe(take(1));
        }),
      )
      .subscribe(() => this.dpnItemFileFacade.setInitialState());
  }
}
